<template>
  <div
    id="form-search-popover"
    class="component-card container-app-search">
    <j-title-header :options="title"/>

    <b-row>
      <b-col md="4">
        <b-form-group :class="{'error-input' : $v.bantuan.tahun_ajaran.$error}">
          <label> Tahun Ajaran </label>
          <j-single-select
            v-model="$v.bantuan.tahun_ajaran.$model"
            :options="list_tahun_ajaran"
            :placeholder="'Select Tahun Ajaran'"
            value-format="object"
            label="tahunajaran"
            @getData="getDataKelas"/>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group :class="{'error-input' : $v.bantuan.semester.$error}">
          <label> Semester </label>
          <j-single-select
            v-model="$v.bantuan.semester.$model"
            :options="list_semester"
            :placeholder="'Pilih Semester'"
            :disabled="!bantuan.tahun_ajaran"
            value-format="object"
            label="name"/>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group :class="{'error-input' : $v.bantuan.kelas.$error}">
          <label> Kelas </label>
          <j-single-select
            v-model="$v.bantuan.kelas.$model"
            :options="list_kelas"
            :placeholder="'Select Kelas'"
            :disabled="!bantuan.semester"
            value-format="object"
            label="name"/>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div class="float-to-right m__t--20 m__b--20">
          <b-button
            :disabled="!bantuan.tahun_ajaran || !bantuan.semester || !bantuan.kelas"
            class="btn blue"
            @click="cariData">
            Cari
          </b-button>
        </div>
      </b-col>
    </b-row>

    <v-server-table
      v-if="show_table"
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="openEditModal">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="openCreateModal">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
        </b-form>
      </div>
    </v-server-table>
    <jLoadingTable v-if="show_table && !load_first"/>

    <b-modal
      ref="modalCreate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Create Data</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_bantuan.nis.$error}">
            <label> Siswa </label>
            <j-single-select
              v-model="$v.data_bantuan.nis.$model"
              :options="list_siswa"
              :placeholder="'Pilih Siswa'"
              value-format="object"
              label="name"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_bantuan.title.$error}">
            <label> Title </label>
            <j-input
              v-model="$v.data_bantuan.title.$model"
              placeholder="Title"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_bantuan.attachment.$error}">
            <label> File </label>
            <j-upload-file
              v-model="$v.data_bantuan.attachment.$model"
              :accepted-file-type="['xls', 'xlsx', 'docx', 'doc', 'pdf', 'jpg', 'png', 'jpeg']"
              :api-token="token"
              :img-default="$v.data_bantuan.attachment.$model"
              :url-upload="url_upload"
              @url="getUrl"/>
              <!-- <j-singleupload
              v-model="$v.data_bantuan.attachment.$model"
              :accepted-file-type="['xls', 'xlsx', 'docx', 'doc', 'pdf', 'jpg', 'png', 'jpeg']"
              :api-token="token"
              :img-default="$v.data_bantuan.attachment.$model"
              :url-upload="url_upload"
              @url="getUrl"/>
            <label>
              Please choose file with supported format file
              xls, xlsx, docx, doc, pdf, jpg, png, jpeg.
            </label> -->
          </b-form-group>

          <j-form-base
            v-if="showAdditionalInfo"
            ref="jFormCreate"
            :data-fields="dataFields"/>
        </b-col>
      </b-row>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue m__r--5"
          @click="saveData">
          Save
        </b-button>
        <b-button
          class="btn gray"
          @click="closeModalCreate">
          Cancel
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalUpdate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Update Data</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_bantuan.nis.$error}">
            <label> Siswa </label>
            <j-single-select
              v-model="$v.data_bantuan.nis.$model"
              :options="list_siswa"
              :placeholder="'Pilih Siswa'"
              :disabled="readOnly"
              value-format="object"
              label="name"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_bantuan.title.$error}">
            <label> Title </label>
            <j-input
              v-model="$v.data_bantuan.title.$model"
              :disabled="readOnly"
              placeholder="Title"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_bantuan.attachment.$error}">
            <label> File </label>
            <j-upload-file
              v-if="showAdditionalInfo"
              v-model="$v.data_bantuan.attachment.$model"
              :accepted-file-type="['xls', 'xlsx', 'docx', 'doc', 'pdf', 'jpg', 'png', 'jpeg']"
              :api-token="token"
              :img-default="$v.data_bantuan.attachment.$model"
              :name-default="fileNameDefault"
              :url-upload="url_upload"
              :disabled="readOnly"
              @url="getUrl"/>
              <!-- <j-singleupload
              v-model="$v.data_bantuan.attachment.$model"
              :accepted-file-type="['xls', 'xlsx', 'docx', 'doc', 'pdf', 'jpg', 'png', 'jpeg']"
              :api-token="token"
              :img-default="$v.data_bantuan.attachment.$model"
              :url-upload="url_upload"
              @url="getUrl"/>
            <label>
              Please choose file with supported format file
              xls, xlsx, docx, doc, pdf, jpg, png, jpeg.
            </label> -->
          </b-form-group>

          <j-form-base
            v-if="showAdditionalInfo"
            ref="jFormUpdate"
            :data-fields="dataFields"
            :is-detail="true"
            :is-disabled="readOnly"/>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3">
          <b-button
            v-if="!readOnly"
            class="btn red m__t--20"
            @click="deleteData">
            Delete
          </b-button>
        </b-col>
        <b-col md="9">
          <div class="float-to-right m__t--20">
            <!-- <b-button
              class="btn green m__r--5"
              @click="submitData">
              Submit
            </b-button> -->
            <b-button
              v-if="!readOnly"
              class="btn blue m__r--5"
              @click="updateData">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="closeModalUpdate">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKesiswaan from '@/services/jApiKesiswaan';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jFormBase from '@/views/kurikulum/additional-info/jFormBase';
import jUploadFile from '@/components/upload-file/jUploadFile';

export default {
  components: {
    jLoadingTable,
    jFormBase,
    jUploadFile,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Data Calon Penerima Bantuan',
      },

      list_tahun_ajaran: [],
      list_konseling: [],
      list_kelas: [],
      list_siswa: [],
      list_semester: [
        { id: 'ganjil', name: 'Ganjil' },
        { id: 'genap', name: 'Genap' },
      ],

      bantuan: {
        tahun_ajaran: null,
        semester: null,
        kelas: null,
      },
      data_bantuan: {
        nis: null,
        type: null,
        title: '',
        semester: null,
        category_id: '13',
        attachment: null,
        additional_info: [],
        tahunajaran: null,
        kode_kelas: null,
        kode_ekskul: null,
      },
      list_type: [
        { id: 'Konseling', name: 'Konseling' },
      ],
      token: (JSON.parse(localStorage.getItem('Token'))).value,
      dataFields: [],
      fileNameDefault: '',
      showAdditionalInfo: false,
      load_first: false,
      show_table: false,
      data_table: [],
      selected_rows: [],
      columns: ['id', 'title'],
      options: {
        headings: {
          id: 'ID',
          title: 'TITLE',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: [],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            status: 'draft',
            module_id: 7,
            category_id: 13,
            tahunajaran: data.tahunajaran ? data.tahunajaran : '',
            semester: data.semester ? data.semester : '',
            kode_kelas: data.kode_kelas ? data.kode_kelas : '',
            limit: data.limit,
            page: data.page,
          };
        },
        requestFunction(data) {
          const getList = jApiKesiswaan.getListDocument(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },
    };
  },
  computed: {
    url_upload() {
      return `${process.env.GATE_URL}file/upload`;
    },
  },
  watch: {
  },
  created() {
    this.listTahunAjaran();
    this.getDataAdditionalInfo();
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKesiswaan', [
      'getAdditionalInfo', 'createDocument', 'updateDocument', 'detailDocument', 'deleteDocument', 'submitDocument',
      'getListTahunAjaran', 'getListKelas', 'getListSiswaByKelas',
    ]),

    listTahunAjaran() {
      const paramTahunAjaran = {
        pagination: {
          query: '',
          query_type: '',
        },
      };
      this.getListTahunAjaran(paramTahunAjaran).then((res) => {
        this.list_tahun_ajaran = res.data.data;
      });
    },

    getDataAdditionalInfo() {
      this.getAdditionalInfo(13).then((res) => {
        this.dataFields = res.data.data.map(el => ({
          id: el.id,
          name: el.field_name,
          type: el.type,
          placeholder: el.placeholder,
          field_key: el.field_key,
          is_delete: false,
          is_editable: false,
          is_mandatory: false,
        }));
      });
    },

    getDataKelas() {
      const params = {
        pagination: {
          query: this.bantuan.tahun_ajaran.tahunajaran,
          query_type: 'tahunajaran',
        },
      };
      this.getListKelas(params).then((res) => {
        this.list_kelas = res.data.data;
        this.bantuan.kelas = null;
      });
    },

    cariData() {
      this.show_table = true;
      if (this.load_first) {
        this.$refs.tableServer.getData();
      }
      const params = {
        kode_kelas: this.bantuan.kelas.kode,
        tahunajaran: this.bantuan.tahun_ajaran.tahunajaran,
      };
      this.getListSiswaByKelas(params).then((res) => {
        this.list_siswa = res.data.data;
      });
    },

    getUrl(data) {
      this.data_bantuan.attachment = data;
    },

    loading(val) {
      const a = val;
      a.tahunajaran = this.bantuan.tahun_ajaran.tahunajaran;
      a.semester = this.bantuan.semester.id;
      a.kode_kelas = this.bantuan.kelas.kode;

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    openCreateModal() {
      this.$refs.modalCreate.show();
      this.showAdditionalInfo = true;
      this.data_bantuan = {
        nis: null,
        type: 'Penelusuran Calon Penerima Bantuan',
        title: '',
        semester: this.bantuan.semester.id,
        category_id: '13',
        attachment: null,
        additional_info: [],
        tahunajaran: this.bantuan.tahun_ajaran.tahunajaran,
        kode_kelas: this.bantuan.kelas.kode,
        kode_ekskul: null,
      };
    },

    closeModalCreate() {
      this.$refs.modalCreate.hide();
      this.showAdditionalInfo = false;
      this.data_bantuan = {
        nis: null,
        type: null,
        title: '',
        semester: null,
        category_id: '13',
        attachment: null,
        additional_info: [],
        tahunajaran: null,
        kode_kelas: null,
        kode_ekskul: null,
      };
      setTimeout(() => {
        this.$v.data_bantuan.$reset();
      }, 1000);
    },

    closeModalUpdate() {
      this.$refs.modalUpdate.hide();
      this.showAdditionalInfo = false;
      this.data_bantuan = {
        nis: null,
        type: null,
        title: '',
        semester: null,
        category_id: '13',
        attachment: null,
        additional_info: [],
        tahunajaran: null,
        kode_kelas: null,
        kode_ekskul: null,
      };
      setTimeout(() => {
        this.$v.data_bantuan.$reset();
      }, 1000);
    },

    openEditModal(param) {
      this.$refs.modalUpdate.show();

      const params = {
        id: param.row.id,
      };
      this.detailDocument(params).then((res) => {
        const nisSelected = this.list_siswa.find(f => f.nis === param.row.nis);
        this.data_bantuan = {
          id: param.row.id,
          nis: nisSelected || null,
          type: 'Penelusuran Calon Penerima Bantuan',
          semester: param.row.semester,
          title: param.row.title,
          category_id: '13',
          attachment: param.row.attachment,
          additional_info: [],
          tahunajaran: this.bantuan.tahun_ajaran.tahunajaran,
          kode_kelas: this.bantuan.kelas.kode,
          kode_ekskul: null,
        };
        this.dataFields = res.data.data.additional_info.map(el => ({
          id: el.id,
          name: el.field_name,
          type: el.type,
          placeholder: el.placeholder,
          field_key: el.field_key,
          value: el.value,
          is_delete: false,
          is_editable: false,
          is_mandatory: false,
        }));
        this.fileNameDefault = res.data.data.attachment_name || '-';
        this.showAdditionalInfo = true;
      });
    },

    saveData() {
      this.$v.data_bantuan.$touch();
      if (!this.$v.data_bantuan.$error) {
        this.$refs.jFormCreate.getData().then((params) => {
          this.data_bantuan.nis = this.data_bantuan.nis ? this.data_bantuan.nis.nis : '';
          this.data_bantuan.additional_info = params.map(e => ({
            field_key: e.field_key,
            value: e.value,
          }));
          this.createDocument(this.data_bantuan).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalCreate();
              }, 1500);
            }
          });
        });
      }
    },

    updateData() {
      this.$v.data_bantuan.$touch();
      if (!this.$v.data_bantuan.$error) {
        this.$refs.jFormUpdate.getData().then((params) => {
          this.data_bantuan.nis = this.data_bantuan.nis ? this.data_bantuan.nis.nis : '';
          this.data_bantuan.additional_info = params.map(e => ({
            field_key: e.field_key,
            value: e.value,
          }));
          this.updateDocument(this.data_bantuan).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_bantuan.id,
          };
          this.deleteDocument(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        }
      });
    },

    submitData() {
      this.$swal({
        title: 'Submit Data',
        text: 'Are you sure want to submit this data?',
        showCancelButton: true,
        confirmButtonText: 'Submit',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_bantuan.id,
          };
          this.submitDocument(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        }
      });
    },
  },
  validations() {
    return {
      bantuan: {
        tahun_ajaran: { required },
        kelas: { required },
        semester: { required },
      },
      data_bantuan: {
        nis: { required },
        title: { required },
        attachment: { },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/bimbingan-konseling/calon-penerima-bantuan/jBantuanList.vue